import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { Options } from '@emotion/cache';

/**
 * RTL runs before Stylis `prefixer`. Multiple Stylis copies in the bundle can crash prefixer; Vite should dedupe `stylis`.
 */
export const commonCache: Options = {
  key: 'muirtl',
  stylisPlugins: [rtlPlugin, prefixer]
};
